import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ReplikaChatExampleStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }

    .img-container {
      display: flex;
      align-items: center;
      flex-grow: 1;
      width: 100%;
      max-width: 310px;
      padding: 0 16px;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }
  }
`;
